const AnnouncementsManagerTab = {
  POSTS: 'POSTS',
  COMMUNITIES: 'COMMUNITIES',
  REPORTS: 'REPORTS',
  NOTIFICATIONS: 'NOTIFICATIONS',
};

const announcementsManagerPagesConfig = {
  [AnnouncementsManagerTab.POSTS]: {
    id: AnnouncementsManagerTab.POSTS,
    path: 'posts',
  },
  [AnnouncementsManagerTab.COMMUNITIES]: {
    id: AnnouncementsManagerTab.COMMUNITIES,
    path: 'communities',
  },
  [AnnouncementsManagerTab.NOTIFICATIONS]: {
    id: AnnouncementsManagerTab.NOTIFICATIONS,
    path: 'notifications',
  },
  [AnnouncementsManagerTab.REPORTS]: {
    id: AnnouncementsManagerTab.REPORTS,
    path: 'reports',
  },
};

const getTabPath = (tab) => announcementsManagerPagesConfig[tab]?.path || '';

export {
  AnnouncementsManagerTab,
  announcementsManagerPagesConfig,
  getTabPath,
};
